module.exports = __webpack_public_path__ + "img/genera-logo.08aa0600.png";